/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Pipe, PipeTransform} from '@angular/core';

import {formatLocaleDate} from '../locale/locale-date-format';
import {AppLocaleService} from '../locale/app-locale.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Pipe({
  standalone: true,
  name: 'localeDate',
  pure: false
})
export class LocaleDatePipe implements PipeTransform {
  constructor(
    private readonly appLocale: AppLocaleService,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any
  ) {
  }

  transform(value: Date | string | number | null | undefined, format = 'medium'): string | null {
    const next = (value === null || value === undefined || value === '')
      ? null
      : formatLocaleDate(
        value,
        format,
        this.appLocale.getLocaleId(),
        this.LocalNetworkProfile.get('timeZone') || 'utc'
      );
    return next;
  }
}
